import { ACCOUNTS_BASE_PATH } from "../redesign/Accounts/paths";

export const SKILLS_ASSESSMENT_PATH = "skills-assessment";
export const SKILLS_ASSESSMENT_BASE_PATH = `${ACCOUNTS_BASE_PATH}/${SKILLS_ASSESSMENT_PATH}`;
